export type label = { [key: string]: string | label[] };
interface IBreadcrumbLabels {
  [key: string]: label;
}

export const BreadcrumbLabels: IBreadcrumbLabels = {
  "teachers-reports": { label: "Teachers reports" },
  "grades-reports": { label: "Grades reports" },
  "other-reports": { label: "Other reports" },
  accounts: {
    label: "Accounts",
    tab: [
      {
        label: "Teachers",
        path: "/accounts/teachers",
      },
      {
        label: "Classes",
        path: "/accounts/classes",
      },
    ],
  },
  classes: {
    label: "Classes",
  },
  teachers: {
    label: "Teachers",
  },
};
